import styles from "./AuthenticationModal.module.scss";
import exclamation from "../../assets/exclamation.png";
import { useMobileOK } from "../../hooks/useMobileOK";

interface AuthenticationModalProps {
  onClose: () => void;
  onAuthSuccess: (result: any) => void;
}

const AuthenticationModal: React.FC<AuthenticationModalProps> = ({
  onClose,
  onAuthSuccess,
}) => {
  const { startVerification, isLoading, isSDKLoaded } = useMobileOK({
    onSuccess: (result) => {
      console.log('[AuthenticationModal] MobileOK 인증 성공:', result);
      onAuthSuccess(result);
      onClose();
    },
    onError: (error) => {
      console.error('[AuthenticationModal] MobileOK 인증 실패:', error);
      alert(`본인인증 실패: ${error.message}`);
    },
  });

  const handleAuthClick = async () => {
    if (!isSDKLoaded) {
      alert('본인인증 서비스를 불러오는 중입니다. 잠시 후 다시 시도해주세요.');
      return;
    }

    if (isLoading) {
      return;
    }

    try {
      await startVerification({
        usageCode: '01007', // 본인확인
        serviceType: 'telcoAuth',
      });
    } catch (error) {
      console.error('[AuthenticationModal] Error during MobileOK auth:', error);
    }
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContainer}>
        <button onClick={onClose} className={styles.closeButton}>
          &times;
        </button>
        <div className={styles.content}>
          <div className={styles.imageContainer}>
            <img src={exclamation} alt="Exclamation Icon" className={styles.image} />
          </div>
          <h1>
            비대면진료 시범사업 개정('24.12.2. 시행)으로
            <br /> 진료 시, 본인 인증이 필요해요
          </h1>
          <p>
          인증은 <span>6개월</span>마다 진행되며 <br /> 반드시 본인 명의의 핸드폰으로 인증해 주세요.
          </p>
          <p>
            본인인증이 어려울 시, <br /> 하단의 물음표 버튼을 눌러 고객센터로 문의해주세요.
          </p>
        </div>
        <button
          onClick={handleAuthClick}
          className={styles.authenticateButton}
          disabled={isLoading || !isSDKLoaded}
        >
          {isLoading ? '처리 중...' : '본인 인증하기'}
        </button>
      </div>
    </div>
  );
};

export default AuthenticationModal;